export interface PortalTaskModel {
  name: string;
  formType: string;
  sentDate: Date;
  secureLinkId: string;
  deadline: Date;
}

export enum PortalTaskFormType {
  Form = 'Form',
  TeamForm = 'Team Form',
  Evaluation = 'Evaluation',
  Survey = 'Survey'
}
